module.exports = __webpack_public_path__ + "static/media/loadingDark.9036bf38.svg";